import { Injectable } from '@angular/core';
import { AudioService } from '@core/audio/audio.service';

@Injectable({
  providedIn: 'root',
})
export class Wk8AudioService extends AudioService {
  constructor() {
    super();
  }

  public async playReadCheckStart() {
    await this.play('/assets/woordkr8/audio/panel-open.wav').waitForEnd();
  }

  public async playReadCheckCorrect() {
    await this.play('/assets/woordkr8/audio/read-correct.wav').waitForEnd();
  }

  public async playReadCheckIncorrect() {
    await this.play('/assets/woordkr8/audio/read-wrong.wav').waitForEnd();
  }

  public async playActivityCorrect() {
    await this.play('/assets/woordkr8/audio/correct-big.wav').waitForEnd();
  }

  public async playActivityIncorrect() {
    await this.play('/assets/woordkr8/audio/incorrect.wav').waitForEnd();
  }

  public async playNextActivity() {
    await this.play('/assets/woordkr8/audio/transition-whoosh.wav').waitForEnd();
  }

  public async playLevelFilledWord() {
    await this.play('/assets/woordkr8/audio/fill-sentence.wav').waitForEnd();
  }

  public async playLevelCompleted() {
    await this.play('/assets/woordkr8/audio/complete-sentence.wav').waitForEnd();
  }

  public async playReading() {
    await this.play('/assets/woordkr8/audio/reading.wav', { volume: 0.25 }).waitForEnd();
  }

  public async playReadingDone() {
    await this.play('/assets/woordkr8/audio/reading-done.wav', { volume: 0.5 }).waitForEnd();
  }

  public async playDraggableGrab() {
    await this.play('/assets/woordkr8/audio/grab.wav').waitForEnd();
  }

  public async playDraggableDrop() {
    await this.play('/assets/woordkr8/audio/drop.wav').waitForEnd();
  }

  public async playDraggableSnap() {
    await this.play('/assets/woordkr8/audio/snap.wav').waitForEnd();
  }

  public async playClawGrab() {
    await this.play('/assets/woordkr8/audio/claw-grab.wav').waitForEnd();
  }

  public async playClawMoveUp() {
    await this.play('/assets/woordkr8/audio/claw-move-up.mp3').waitForEnd();
  }

  public async playClawMove() {
    await this.play('/assets/woordkr8/audio/claw-move-up.mp3').waitForEnd();
  }

  public async playClawMoveDown() {
    await this.play('/assets/woordkr8/audio/claw-move-down.mp3').waitForEnd();
  }

  public async playCorrect() {
    await this.play('/assets/woordkr8/audio/correct.wav').waitForEnd();
  }

  public async playIncorrect() {
    await this.play('/assets/woordkr8/audio/incorrect.wav').waitForEnd();
  }

  public async playClawSnap() {
    await this.play('/assets/woordkr8/audio/claw-snap.wav').waitForEnd();
  }

  public async playConveyor() {
    await this.play('/assets/woordkr8/audio/conveyor.mp3').waitForEnd();
  }

  public async playPipeSuck() {
    await this.play('/assets/woordkr8/audio/pipe-suck.mp3').waitForEnd();
  }

  public async playReset() {
    await this.play('/assets/woordkr8/audio/reset.wav').waitForEnd();
  }
}
